export default {"src":"/_next/static/media/lightning.cfb32f6b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};